<template>
  <div>
    <title-bar :title="title">
      <el-button type="primary" @click="save" icon="fa fa-save" :loading="loading">保存</el-button>
      <el-button @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
    </title-bar>
    <div class="page-body">
      <el-form inline>
        <el-form-item label="日期">
          <el-date-picker v-model="dates" type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="fa fa-search" :loading="loading" @click="query">查询</el-button>
      </el-form>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center" fixed></el-table-column>
        <el-table-column prop="dt" label="日期" align="center" min-width="80" fixed></el-table-column>
        <el-table-column prop="weekday" label="星期" align="center" min-width="60" fixed v-slot="{row, $index}">
          <span>{{getWeekdayCn(row.weekday)}}</span>
        </el-table-column>
<!--        <el-table-column prop="kwh" label="电表(KWH)" align="center" min-width="90"></el-table-column>-->
        <el-table-column prop="dayKwh" label="日耗电(KWH)" align="center" min-width="90" v-slot="{row, $index}">
          <el-input-number v-model="row.dayKwh" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
<!--        <el-table-column prop="money" label="预估节能(元)" align="center" min-width="90" v-slot="{row, $index}">
          <el-input-number v-model="row.money" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>-->
        <el-table-column prop="minInTemp" label="最低室内温度1(℃)" align="center" min-width="100" v-slot="{row, $index}">
          <el-input-number v-model="row.minInTemp" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
        <el-table-column prop="maxInTemp" label="最高室内温度1(℃)" align="center" min-width="100" v-slot="{row, $index}">
          <el-input-number v-model="row.maxInTemp" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
        <el-table-column prop="minInTemp2" label="最低室内温度2(℃)" align="center" min-width="100" v-slot="{row, $index}">
          <el-input-number v-model="row.minInTemp2" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
        <el-table-column prop="maxInTemp2" label="最高室内温度2(℃)" align="center" min-width="100" v-slot="{row, $index}">
          <el-input-number v-model="row.maxInTemp2" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
        <el-table-column prop="minOutTemp" label="最低室外温度(℃)" align="center" min-width="100" v-slot="{row, $index}">
          <el-input-number v-model="row.minOutTemp" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
        <el-table-column prop="maxOutTemp" label="最高室外温度(℃)" align="center" min-width="100" v-slot="{row, $index}">
          <el-input-number v-model="row.maxOutTemp" :controls="false" style="width: 100%"></el-input-number>
        </el-table-column>
        <el-table-column label="运行时间统计（分钟）" align="center">
          <el-table-column prop="acRunMinutes" label="空调" align="center" min-width="100" v-slot="{row, $index}">
            <el-input-number v-model="row.acRunMinutes" :controls="false" style="width: 100%"></el-input-number>
          </el-table-column>
          <el-table-column prop="fanRunMinutes" label="新风" align="center" min-width="100" v-slot="{row, $index}">
            <el-input-number v-model="row.fanRunMinutes" :controls="false" style="width: 100%"></el-input-number>
          </el-table-column>
        </el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
      <div class="button-container" style="margin-top: 20px;">
        <el-button type="primary" @click="save" icon="fa fa-save" :loading="loading">保存</el-button>
        <el-button @click="$router.back()" icon="fa fa-angle-left">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      title: "数据调整",
      device: null,
      dates: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryForm: {
        deviceCode: '',
        startDate: '',
        endDate: '',
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    this.queryForm.deviceCode = this.$route.query.deviceCode;
    this.postForm("/device/getDevice", {
      deviceCode: this.queryForm.deviceCode
    }).then(dr => {
      this.device = dr.bean;
      this.title = this.title + "("+this.device.deviceCode+" "+this.device.deviceName+")";
    })
    this.loadData();
  },
  methods: {
    query(){
      if(this.dates.length > 0) {
        this.queryForm.startDate = this.dates[0];
        this.queryForm.endDate = this.dates[1];
      }
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-day-info/v2/list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    save(){
      this.loading = true;
      this.postJson("//device-day-info/save?deviceCode="+this.queryForm.deviceCode, this.records, true).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>